import React, {useEffect,useState,useContext} from 'react'
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'
import { ContentContainer,ListItem,createDialog } from 'coaz-ui'
import { PiBookLight, PiFilePdfFill, PiFilePdfLight, PiStarLight, PiUserLight } from 'react-icons/pi'
import client from '../client'
import { GlobalContext } from '../contexts/GlobalContext';
import { PiTextAlignLeftLight } from 'react-icons/pi'
import ContentColumn from './ContentColumn'
import ContentRow from './ContentRow'
import ContentRowItem from './ContentRowItem'
import AddFile from './AddFile'

const Topic = () => {
	const [topic,setTopic] = useState(null);
	const [fileResources,setFileResources] = useState([]);
	const [completion,setCompletion] = useState(null);
	const [loading,setLoading] = useState(true);
	const [buttons,setButtons] = useState([]);
	const { programId,cpdId,topicId, fileId} = useParams();
	const path = useLocation().pathname;
	const {version,setVersion} = useContext(GlobalContext);

	const {request,getCurrent} = client;

	const getTopic = async () => {
		if(!topicId) return;

		try {
			const response = await request("GET",`topics/${topicId}`,null,{bypassReservedCheck:true})

			if(response) {
				setTopic(response)
			} else {
				setTopic(null)
			}
		} catch(error) {
			setTopic(null)
		}
	}

	const getFileResources = async () => {
		if(!programId || !cpdId || !topicId) return;

		try {
			let curr = await getCurrent();

			if(!curr || !curr.user) return;

			const cpdStudent = await request("GET","cpd-students",null,{
				userReference:curr.user.ref.value,
				programId:programId,
				cpdId:cpdId
			})

			if(!cpdStudent || !cpdStudent.teacher || !cpdStudent.teacher.user) return;

			let btns = [
				{
					Icon:PiFilePdfLight,
					name: "Add File",
					handler: onAddFile
				}
			];

			setButtons(btns);

			const response = await request("GET","file-resources/by-teacher-topic",null,{
				teacherReference:cpdStudent.teacher.user.ref.value,
				topicId:topicId})

			if(response && response.length > 0) {
				setFileResources(response)
			} else {
				setFileResources([])
			}
		} catch(error) {
			setFileResources([])
		}
	}

	const onAddFile = (e) => {
		e.preventDefault();
		createDialog({
			title: "Add File",
			Component: AddFile,
			params: { topicId: topicId },
			version: version,
			setVersion: setVersion,
		});
	}

	const navigate = useNavigate();

	const onOpenFile = (item) => {
		if(!item || !item.id) return;

		navigate(`${path}/_file/${item.id}`)
	}

	const load = async () => {
		setLoading(true);
		await getTopic();
		await getFileResources();
		setLoading(false);
	}

	useEffect(() => {
		load();
	},[version])

	if(fileId) 
		return (
			<Outlet/>
	)
  return (
	<ContentContainer
		Icon={PiTextAlignLeftLight}
		text={`${topic?.name ?? ""}`}
		scrollable={true}
		loading={loading}
		buttons={buttons}
	>
		{topic &&
		<ContentColumn>
			<ContentRow>
				{fileResources.length > 0 && (
					<ContentRowItem title="Files">
						<div className='flex flex-col space-y-2 p-2'>
						{fileResources.map((file, i) => (
							<ListItem
								key={file.ref?.id ?? i}
								Icon={PiFilePdfLight}
								item={{
									id: file.ref?.id,
									text: file.name
								}}
								handleOpen={onOpenFile}
							/>
						))}
						</div>
					</ContentRowItem>
				)}
			</ContentRow>
		</ContentColumn>
		}
	</ContentContainer>
  )
}

export default Topic